import { render, staticRenderFns } from "./go-question.vue?vue&type=template&id=7bb99d1e&scoped=true&"
import script from "./go-question.vue?vue&type=script&lang=js&"
export * from "./go-question.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb99d1e",
  null
  
)

export default component.exports